import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      testid="privacy-page"
      eyebrow="Legal"
      title="Privacy Policy"
      sections={[
        { h: "What we collect", p: "When you contact Heart N Soul Records or place an order, we collect the details you provide — such as your name, email address, and shipping information — solely to respond to you and fulfill your request." },
        { h: "How we use it", p: "Your information is used to reply to inquiries, process merch orders, and share updates you opt into. We do not sell your personal data." },
        { h: "Cookies & analytics", p: "We may use privacy-respecting analytics to understand how the site is used and to improve it." },
        { h: "Contact", p: "Questions about your data? Email hello@heartnsoulrecords.com and we will help." },
      ]}
    />
  );
}
